import { Card, Col, Skeleton } from 'antd'
import { Link } from 'gatsby'
import * as _ from 'lodash'
import * as React from 'react'
import { DynamicImage } from './DynamicImage'

import { StyledCard, EmptyCard } from '../styles/styledComponents'
import { Product } from '../types'

const { Meta } = Card

export const CourseCard = ({
  product,
  isMyCourse,
}: {
  product: Product
  isMyCourse: boolean
}) => {
  const productCardLink = isMyCourse
    ? product.metadata.startPath
    : product.metadata.slug
  return (
    <Col md={{ span: 10, offset: 1 }} sm={{ offset: 1, span: 22 }}>
      <Link to={`${productCardLink}`}>
        <StyledCard
          hoverable
          cover={
            product.metadata.image ? (
              <DynamicImage
                filename={product.metadata.image}
                alt={`${product.name} Logo`}
              />
            ) : null
          }
        >
          <Skeleton
            loading={!product.metadata.image}
            avatar={{ shape: 'square' }}
            active
          >
            <Meta title={product.name} description={product.description} />
          </Skeleton>
        </StyledCard>
      </Link>
    </Col>
  )
}

export const LoadingCourseCard = () => (
  <Col md={{ span: 10, offset: 1 }} sm={{ offset: 1, span: 22 }}>
    <StyledCard>
      <Skeleton loading={true} avatar={{ shape: 'square' }} active />
    </StyledCard>
  </Col>
)

export const EmptyCourseCard = () => (
  <Col md={{ span: 8, offset: 8 }} sm={{ offset: 1, span: 22 }}>
    <EmptyCard>
      <Meta
        title="No courses added- so sad! 😢"
        description={`Why don't you go over to the courses page and add one?`}
      />
    </EmptyCard>
  </Col>
)
